<template>
  <div class="item-form-page">
    <!-- Sticky Actions Bar -->
    <div class="item-form-page__actions-bar pr-4">
      <v-alert v-if="errorMessage" type="error" dense dismissible class="mb-2 flex-grow-1" @input="errorMessage = ''">
        {{ errorMessage }}
      </v-alert>
      <div class="d-flex justify-space-between align-center">
        <span class="text-styled-h3 white--text pa-0 ma-0 mt-3">Editing {{ draft.title }}</span>

        <div class="d-flex justify-end align-center">
          <v-btn light color="amber" class="mr-2" @click="handleSubmit">
            {{ isEditing ? 'Update' : 'Create' }}
          </v-btn>
          <v-btn light color="grey" @click="handleCancel">
            Cancel
          </v-btn>
        </div>
      </div>
    </div>

    <offer-details-body :draft="draft" :doc="doc" :show-group-field="false" title-field="title" title-label="Title"
      :errors="errors" @clear-error="clearError" />

    <div class="d-flex justify-space-between align-center mt-4">
      <div></div>
      <div class="d-flex justify-end align-center">
        <v-btn light color="amber" class="mr-2" @click="handleSubmit">
          {{ isEditing ? 'Update' : 'Create' }}
        </v-btn>
        <v-btn light color="grey" @click="handleCancel">
          Cancel
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import OfferDetailsBody from './OfferDetailsBody'
import { groupModel, deepClone, toSlug } from './model'

const buildDraft = (item) => {
  const base = deepClone(groupModel)
  if (!item) return base
  const merged = { ...base }
  for (const key of Object.keys(item)) {
    if (item[key] !== undefined) {
      merged[key] = deepClone(item[key])
    }
  }
  return merged
}

export default {
  name: 'ColFormFacilitated',

  components: {
    OfferDetailsBody,
  },

  props: {
    item: {
      type: Object,
      default: null,
    },
    doc: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      draft: buildDraft(this.item),
      errorMessage: '',
      errors: {
        title: false,
      },
    }
  },

  computed: {
    isEditing() {
      return !!this.item?.id
    },
  },

  watch: {
    item: {
      handler(val) {
        this.draft = buildDraft(val)
        this.errorMessage = ''
        this.errors = { title: false }
      },
    },
  },

  methods: {
    handleSubmit() {
      this.errorMessage = ''
      this.errors = { title: false }

      if (!this.draft.title?.trim()) {
        this.errors.title = true
        this.errorMessage = 'Title is required'
        return
      }

      this.$emit('submit', {
        ...deepClone(this.draft),
        name: toSlug(this.draft.title),
      })
    },

    handleCancel() {
      this.$emit('cancel')
    },

    clearError(field) {
      if (this.errors[field]) {
        this.errors[field] = false
      }
      if (this.errorMessage) {
        this.errorMessage = ''
      }
    },

    reset() {
      this.draft = buildDraft(this.item)
      this.errorMessage = ''
      this.errors = { title: false }
    },
  },
}
</script>

<style lang="scss" scoped>
.item-form-page {
  padding: 0;

  &__actions-bar {
    position: sticky;
    top: 0;
    z-index: 10;
    background: #1e1e1e;
    padding: 12px 0;
    margin-bottom: 16px;
    // border-bottom: 1px solid #e0e0e0;
  }
}
</style>
